import { useState } from 'react';
import { HighlightedCode } from '../HighlightedCode';

export function InstantiatedTemplateRow({
  category,
  templateId,
  config,
}: {
  category: string;
  templateId?: string;
  config?: Record<string, unknown>;
}) {
  const [open, setOpen] = useState(false);
  const hasConfig = !!config && Object.keys(config).length > 0;
  return (
    <div className="pipeline-template-row" data-testid="pipeline-instantiated-template-row">
      <div
        className={`pipeline-template-header${hasConfig ? ' clickable' : ''}`}
        onClick={hasConfig ? (e) => { e.stopPropagation(); setOpen(!open); } : undefined}
        style={hasConfig ? { cursor: 'pointer' } : undefined}
      >
        {hasConfig && <span className="step-expand-icon">{open ? '▾' : '▸'}</span>}
        <span className="pipeline-template-name">{templateId ?? category}</span>
        <span className="pipeline-template-category">{category}</span>
      </div>
      {open && hasConfig && (
        <div className="pipeline-template-details">
          <HighlightedCode
            language="json"
            code={JSON.stringify(config, null, 2)}
            className="tool-detail-json"
          />
        </div>
      )}
    </div>
  );
}
